import {
  CORE_LOAD_USER_INFO_REQUEST,
  CORE_LOAD_USER_INFO_SUCCESS,
  CORE_LOAD_USERS_REQUEST,
  CORE_LOAD_USERS_SUCCESS,
  O365_LOAD_USERS_REQUEST,
  O365_LOAD_USERS_SUCCESS,
  CORE_LOAD_ALL_USERSAD_REQUEST,
  CORE_LOAD_ALL_USERSAD_SUCCESS,
  CORE_SEARCH_USERS_REQUEST,
  CORE_SEARCH_USERS_SUCCESS,
  CORE_RESET_PASSWORD_REQUEST,
  CORE_RESET_PASSWORD_SUCCESS,
  CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST,
  CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS,
  CORE_LOAD_ALL_AD_LIST_REQUEST,
  CORE_LOAD_ALL_AD_LIST_SUCCESS,
  CORE_LOAD_ALL_AD_LIST_FAILURE,

} from "../../types";

const initialState = [];

export default {
  users: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_USERS_REQUEST:
      case CORE_SEARCH_USERS_REQUEST:
        return [];
      case CORE_LOAD_USERS_SUCCESS:
      case CORE_SEARCH_USERS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  usersO365: (state = initialState, action) => {
    switch (action.type) {
      case O365_LOAD_USERS_REQUEST:
        return [];
      case O365_LOAD_USERS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  usersAD: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_USERSAD_REQUEST:
        return [];
      case CORE_LOAD_ALL_USERSAD_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  user: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_USER_INFO_REQUEST:
        return {};
      case CORE_LOAD_USER_INFO_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  resetPassword: (state = {}, action) => {
    switch (action.type) {
      case CORE_RESET_PASSWORD_REQUEST:
        return {};
      case CORE_RESET_PASSWORD_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  importUserO365: (state = [], action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST:
        return [];
      case CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  usersADList: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_AD_LIST_REQUEST:
        return "REQUEST";
      case CORE_LOAD_ALL_AD_LIST_SUCCESS:
        let result = [];
        if (Array.isArray(action.payload)) {
          result = action.payload;
        }
        return result;
      case CORE_LOAD_ALL_AD_LIST_FAILURE:
        return initialState;
      default:
        return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/features/user/reducer.js